import * as ActionTypes from "../actions/actionTypes";
import {
  LicenseAssignmentAction,
} from "../actions/actionTypes";
import {
  LicenseWithOwnerAndSingleUserAssignments
} from "../../model/entitlement/LicenseWithOwnerAndSingleUserAssignments";
import {LicenseWithOwner} from "../../model/entitlement/LicenseWithOwner";
import {LicenseUsage} from "../../model/entitlement/LicenseUsage";
import {License} from "../../model/entitlement/License";
import {LicensesById} from "../store/LicensesState";
/**
 * Updates stored license data (if stored data exists) with the given new data.
 * @param newLicense New license data.
 * @param oldLicense Old license data, if old license data exists.
 */
function updateLicense<T extends License>(
    newLicense: T,
    oldLicense?: T
): T {
  let retValue: T;

  if (oldLicense) {
    retValue = { ...oldLicense, ...newLicense };
  } else {
    retValue = newLicense;
  }

  return retValue;
}
export default function licenses(
  state: LicensesById,
  action: ActionTypes.AppAction
): LicensesById | null {
  const currentState = state || ({} as LicensesById);
  switch (action.type) {
    case ActionTypes.QUERY_AVAILABLE_LICENSES:
      const licensesAction = action as ActionTypes.LicensesAction;
      const licenses = licensesAction.licenses;
      const stateAfterOperation = { ...currentState };
      for (const license of licenses) {
        const licenseId = license.id as string;
        // Strip out members that are not part of the result type: LicenseWithOwner & LicenseUsage
        const {
          assignments,
          licenseAssignments,
          ...typedLicense
        } = license as LicenseWithOwnerAndSingleUserAssignments & LicenseAssignmentAction;
        stateAfterOperation[licenseId] = updateLicense<LicenseWithOwner & LicenseUsage>(
            typedLicense as LicenseWithOwner & LicenseUsage,
            stateAfterOperation[licenseId]
        );
      }
      return stateAfterOperation;
      /*
    case ActionTypes.RELEASE_LICENSE_LEASE:
      const releaseLicenseLeaseAction = action as ReleaseLicenseLeaseAction;
      return releaseLicenseLease(releaseLicenseLeaseAction.release, releaseLicenseLeaseAction.result, currentState);
       */
    case ActionTypes.ADD_ERROR:
      return handleErrorAction(currentState, action);
    case ActionTypes.START_AUTHN:
    case ActionTypes.SET_LOGOUT_COMPLETED:
      return null;
    default:
      return state || null;
  }
}

function handleErrorAction(
  currentState: LicensesById,
  action: ActionTypes.AppAction
): LicensesById {
  return currentState;
}
